angular.module('bmsApp.trugreen.product').factory('TGProductSvc', function (CRUDSvc) {

	var self = {
		lowStockIndicator: function (params) {
			return CRUDSvc.get('api/trugreen/product/low-stock-indicator', params);
		},
		productList: {
			index: function (params) {
				return CRUDSvc.get('api/trugreen/productList/index', params);
			},
			read: function (params, id) {
				return CRUDSvc.read('api/trugreen/productList/read', id);
			}
		}
	};
	return self;

});
